let shadows;
export default {
  // inject:['marsMap','marsMeasure'],
  props: ["dateSelection", "sunshineTime"],
  data() {
    return {
      sunshineAnalysis_show: true,
      sunshineTimeVal: 7,
      currentDate: "",
      isFold: false,
    };
  },
  methods: {
    adjustSunshineTime() {
      // alert("触发！");
      //this.$emit('changeSunshineTime', this.sunshineTimeVal);
      shadows.time = this.getCurrentTime();
      console.log(shadows.time);
    },
    sunshineAnalysisBox_close() {
      // this.transparency_show = false;
      this.$emit("sunshineAnalysisBox_close");
    },
    autoplay() {
      let currentTime = this.getCurrentTime();
      let startDateTime = new Date(this.currentDate + " 00:00:00");
      let endDateTime = new Date(this.currentDate + " 23:59:59");
      if (currentTime >= endDateTime) {
        this.$alert("开始时间必须小于结束时间。", "友情提示", {
          confirmButtonText: "确定",
          type: "warning",
          callback: (action) => {},
        });
        return;
      }
      shadows.start(startDateTime, endDateTime, currentTime);
      this.$message({
        message: "已开始 自动播放。",
        type: "success",
        offset: 100,
        showClose: true,
        duration: 1600,
      });
    },
    pausePlayback() {
      shadows.pause();
      this.$message({
        message: "已暂停 自动播放。",
        type: "success",
        offset: 100,
        showClose: true,
        duration: 1600,
      });
    },
    getCurrentTime() {
      //alert(this.currentDate);
      //alert(this.sunshineTimeVal);
      let strDateTime =
        this.currentDate + " " + this.sunshineTimeVal + ":00:00";
      return new Date(strDateTime);
    },
  },
  mounted() {
    if (this.dateSelection) {
      this.currentDate = this.dateSelection;
    } else {
      // 获取当前日期
      let date = new Date();
      // 获取当前月份
      let nowMonth = date.getMonth() + 1;
      // 获取当前是几号
      let strDate = date.getDate();
      // 添加分隔符“-”
      let seperator = "-";
      // 对月份进行处理，1-9月在前面添加一个“0”
      if (nowMonth >= 1 && nowMonth <= 9) {
        nowMonth = "0" + nowMonth;
      }
      // 对月份进行处理，1-9号在前面添加一个“0”
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      // 最后拼接字符串，得到一个格式为(yyyy-MM-dd)的日期
      let nowDate =
        date.getFullYear() + seperator + nowMonth + seperator + strDate;
      this.currentDate = nowDate;
    }
    if (this.sunshineTime) {
      this.sunshineTimeVal = this.sunshineTime;
    }

    if (!shadows) {
      shadows = new mars3d.thing.Shadows({
        multiplier: 1600,
        time: this.getCurrentTime(),
      });
      this.$GLOBAL.map.addThing(shadows);
    }

    let that = this;
    //实时更新滑动条上的时间。
    shadows.on(mars3d.EventType.change, function(event) {
      that.sunshineTimeVal = shadows.time.getHours();
    });
  },
  destroyed() {
    let strDateTime = new Date(this.currentDate + " " + "12:00:00");
    shadows.time = strDateTime;
    shadows.clear();
    shadows.off(mars3d.EventType.change);
    this.$GLOBAL.map.removeThing(shadows, true);
    //shadows.destroy();
    shadows = null;
  },
  watch: {},
};
